import { defineMessages } from "react-intl";
const messages = defineMessages({
    scanRequestPolicy: {
        id: "app.users.createUser.scanRequest.policy.text",
        defaultMessage: "Can create & edit scan requests",
    },
    insightsUserRole: {
        id: "app.users.createUser.userRoles.insightsUser.text",
        defaultMessage: "Insights",
    },
    basicUserRole: {
        id: "app.users.createUser.userRoles.basicUser.text",
        defaultMessage: "Basic",
    },
    basicUserDescription: {
        id: "app.users.createUser.userDescriptions.basicUser.text",
        defaultMessage: "Can view & share virtual tours",
    },
    agentUserRole: {
        id: "app.users.createUser.userRoles.agentUser.text",
        defaultMessage: "Agent",
    },
    agentUserDescription: {
        id: "app.users.createUser.userDescriptions.basicUser.text",
        defaultMessage: "Can edit virtual tours & SGT settings (if applicable)",
    },
    scannerUserRole: {
        id: "app.users.createUser.userRoles.scannerUser.text",
        defaultMessage: "Scanner",
    },
    ownerUserRole: {
        id: "app.users.createUser.userRoles.ownerUser.text",
        defaultMessage: "Owner",
    },
    orgAdminUserRole: {
        id: "app.users.createUser.userRoles.orgAdminUser.text",
        defaultMessage: "Organization Admin",
    },
});
export default messages;
